import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFeature } from "src/context/global";

const SettingsRouteGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { pathname } = useLocation();
  const { me }: any = useSelector((state: any) => state.me);
  const { canUse, loading } = useFeature();

  if (loading) return null;
  if (!me) return null;

  // Map your settings routes to feature IDs from your features config
  const pathToFeature: Record<string, string> = {
    "/settings/facebook": "facebook",
    "/settings/instagram": "instagram",
    "/settings/whatsapp": "whatsapp",
    "/settings/twilio": "twilio_sms",
  };

  const featureId = pathToFeature[pathname];

  // Restrict access if user can't use the feature
  if (featureId && !canUse(featureId)) {
    return <Navigate to="/settings/facebook" replace />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default SettingsRouteGuard;
